var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{attrs:{"type":"file","accept":"video/mp4, video/x-m4v, video/*","capture":""},on:{"change":_vm.setvideo}})])}
var staticRenderFns = []

export { render, staticRenderFns }